export default "__VITE_ASSET__DMHl4rrv__"